"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Avatar_1 = __importDefault(require("atomicComponents/atoms/Avatar"));
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var MentionAvatar = function (_a) {
    var _b = _a.mention, avatar = _b.avatar, name = _b.name, collection = _b.collection, hasNoAvatar = _a.hasNoAvatar;
    if (collection === 'services')
        return (0, jsx_runtime_1.jsx)(material_1.Box, { component: Logo_1.default, size: "sm", brand: { logoUrl: avatar, name: name }, mr: 0.5, ml: 0.5 });
    if (hasNoAvatar)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "@" });
    return (0, jsx_runtime_1.jsx)(Avatar_1.default, { size: "sm", src: avatar, alt: name, label: name, sx: { mr: 0.375 } });
};
exports.default = MentionAvatar;
